import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

export interface TitleProps {
  children: ReactNode
}

const StyledTitle = styled.div`
  ${({
    theme: {
      colors: { staticWhite },
      typography: {
        headings: {
          xsmall: { bundledCSS: xsmallHeadingCSS },
        },
      },
      utils: { ellipsis },
    },
  }) => {
    return css`
      ${ellipsis('100%', 2)};
      ${xsmallHeadingCSS};
      color: ${staticWhite};
    `
  }}
`

const Title: FunctionComponent<TitleProps> = ({ children }) => {
  return <StyledTitle>{children}</StyledTitle>
}

export default Title
